const lang = {};

export default lang;



// WEBPACK FOOTER //
// ./src/lang/en.js